import AuthenticatedRoute from 'utils/policies/routes/AuthenticatedRoute';

export default {
  AuthenticatedRoute
};
